import { useQuery } from 'react-query';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { cacheKeys } from './cacheKeys';

export const useGetTopics = (options = {}) => {
  return useQuery(
    cacheKeys.getTopics(options),
    async () => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      const response = await handleRequest(
        'get',
        `facility/${user.facility}/topics`,
        true,
        null,
        options.filter,
      );

      return response.data;
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...options,
    },
  );
};
